module.exports = __webpack_public_path__ + "img/vmware-pulse-iot-center.4c4c8b7a.jpg";